import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Sticky from "react-stickynode";

import { List, ListItem, ListItemText, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { options } from "../data/nav";

// Using Inline Styling
const RootDiv = styled("div")({
  flexGrow: 1,
});

const DropdownMenu = styled("ul")(({ theme }) => ({
  listStyle: "none",
  // padding: 0,
  padding: "10px",
  margin: 0,
  position: "absolute",
  top: "100%",
  right: 0,
  backgroundColor: "white",
  boxShadow: theme.shadows[3],
  borderRadius: "8px", // Rounded corners
  zIndex: 1000,
  display: "none",
  '&[aria-expanded="true"]': {
    display: "block",
  },
  minWidth: "210px",
}));

const DropdownItem = styled(NavLink)(({ theme }) => ({
  // padding: theme.spacing(1, 0.5),
  color: theme.palette.text.primary,
  textDecoration: "none",
  display: "block",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  fontSize: "15px",
}));
const ServicesButton = styled(Button)(({ theme }) => ({
  position: "relative",
  "&:hover > ul": {
    display: "block",
  },
  color: "black",
  fontWeight: "normal",
  cursor: "pointer",
  textTransform: "none",
  fontSize: "16px",
  padding: 0,
}));

export default function Navbar(props) {
  let { onClickService, onClickFeatures, onClickPricing, onClickReview } =
    props;
  
  const small = useMediaQuery("(max-width:900px)");
  const full = useMediaQuery("(min-width:900px)");

  const [open, setOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useNavigate();
  const closeServiceDropdown = (destination) => {
    setServiceOpen(false);
    setAnchorEl(null);
    history(destination);
    window.location.reload();
  };

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Sticky top={0} innerZ={9999}>
      <RootDiv>
        <AppBar
          position="static"
          sx={{
            backgroundColor: "white",
            color: "black",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
            padding: "5px",
          }}
        >
          <Toolbar>
            {small && (
              <>
                <List sx={{ width: "100%" }}>
                  <ListItem
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <Link className={`navbar-brand`} to="/">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img src={require("../img/logo1.png")} alt="" />
                        <img
                          style={{ width: "35px", marginBottom: "15px" }}
                          src={require("../img/urDoer2.png")}
                          alt="logo"
                        />
                        <div
                          style={{
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: "22px",
                            color: "#5E2CED",
                          }}
                        >
                          &nbsp;UrDoer
                        </div>
                      </div>
                    </Link>
                    <Button
                      onClick={handleClick}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "black",
                      }}
                    >
                      {open ? <ExpandLess /> : <ExpandMore />}
                      <MenuIcon sx={{ marginLeft: 1 }} />
                    </Button>
                  </ListItem>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List
                      component="div"
                      sx={{
                        textAlign: "right",
                        marginRight: "2rem",
                        position: "relative",
                      }}
                    >
                      <ServicesButton onClick={onClickService}>
                        {"Services"}
                        <DropdownMenu>
                          {options.map((option, index) => (
                            <li key={index}>
                              <DropdownItem
                                exact
                                onClick={() =>
                                  closeServiceDropdown(
                                    `/services/${option.href}`
                                  )
                                }
                                to={`/services/${option.href}`}
                              >
                                {option.name}
                              </DropdownItem>
                            </li>
                          ))}
                        </DropdownMenu>
                      </ServicesButton>
                      <div>
                        <Link className="custom-link-nav" to="/blog">
                          Blog
                        </Link>
                      </div>
                      <div onClick={onClickFeatures}>
                        <Link to="/" className="custom-link-nav">
                          Features
                        </Link>
                      </div>
                      <div>
                        <Link to="/" className="custom-link-nav">
                          Pricing
                        </Link>
                      </div>
                      <div onClick={onClickReview}>
                        <Link to="/" className="custom-link-nav">
                          Reviews
                        </Link>
                      </div>
                      <div>
                        <Link className="custom-link-nav" to="/tutor_dashboard">
                          Become A Doer
                        </Link>
                      </div>
                      <div>
                        <Link className="custom-link-nav" to="/admin">
                          Admin
                        </Link>
                      </div>
                    </List>
                  </Collapse>
                </List>
              </>
            )}

            {full && (
              <div className="nav-link-cont">
                <Link className={`navbar-brand`} to="/">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={require("../img/logo1.png")} alt="" />
                    <img
                      style={{ width: "35px", marginBottom: "15px" }}
                      src={require("../img/urDoer2.png")}
                      alt="logo"
                    />
                    <div
                      style={{
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: "22px",
                        color: "#5E2CED",
                      }}
                    >
                      &nbsp;UrDoer
                    </div>
                  </div>
                </Link>
                <div
                  style={{
                    gap: "30px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <ServicesButton onClick={onClickService}>
                    {"Services"}
                    <DropdownMenu>
                      {options.map((option, index) => (
                        <li key={index}>
                          <DropdownItem
                            exact
                            onClick={() =>
                              closeServiceDropdown(`/services/${option.href}`)
                            }
                            to={`/services/${option.href}`}
                          >
                            {option.name}
                          </DropdownItem>
                        </li>
                      ))}
                    </DropdownMenu>
                  </ServicesButton>
                  <div>
                    <Link className="custom-link-nav" to="/blog">
                      Blog
                    </Link>
                  </div>

                  <div onClick={onClickFeatures}>
                    <Link to="/" className="custom-link-nav">
                      Features
                    </Link>
                  </div>
                  <div>
                    <Link to="/" className="custom-link-nav">
                      Pricing
                    </Link>
                  </div>

                  <div onClick={onClickReview}>
                    <Link to="/" className="custom-link-nav">
                      Reviews
                    </Link>
                  </div>
                  <div>
                    <Link className="custom-link-nav" to="/tutor_dashboard">
                      Become A Doer
                    </Link>
                  </div>
                  <div>
                    <Link className="custom-link-nav" to="/admin">
                      Admin
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </Toolbar>
        </AppBar>
      </RootDiv>
    </Sticky>
  );
}
